import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "19",
  fill: "none",
  viewBox: "0 0 14 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M7.637 9.302v2.145h5.206c.197-.654.378-1.367.533-2.145zM13.94 4.602q.059-1.102.06-2.32l-.004-.003a4.1 4.1 0 0 1-2.5.846A4.14 4.14 0 0 1 7.637.469v4.133h6.306zM7.637 16.15v2.319s1.409-.398 2.902-2.32zM11.394 14.871c.354-.61.698-1.32 1.014-2.145H7.637v2.145zM7.637 5.878v2.145h5.965a34 34 0 0 0 .253-2.145zM5.091 5.878H3.82v-2.97c-.4.136-.827.211-1.271.215v2.755H1.272V2.933A4.2 4.2 0 0 1 .004 2.28L0 2.283c0 14.386 6.363 16.186 6.363 16.186v-18A4.16 4.16 0 0 1 5.091 2.21z"
    }, null, -1)
  ])))
}
export default { render: render }